import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb } from 'react-bootstrap';
import { useLocation, useParams, Link } from "react-router-dom";
import { getDepartmentChildrenAsLinksArray } from '../../config';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { setBreadcrumbsArray } from '../actions/app';

const Breadcrumbs = ({ breadcrumbs, setBreadcrumbsArray }) => {
  let location = useLocation();
  let { lang } = useParams();

  useEffect(() => {
    const params = location.pathname.split('/').filter(i => ![lang, 'my', ''].includes(i));

    let crumbs = [ { title: gettext('Мой кабинет'), url: '/' } ];
    crumbs = crumbs.concat(getDepartmentChildrenAsLinksArray(params));
    setBreadcrumbsArray(crumbs);
  }, []);


  const getItems = (crumbs) => {
    const lastIndex = crumbs.length - 1;
    return crumbs.map((c, index) => {
      const isLast = index === lastIndex;
      if (Object.keys(c).includes('url') && !isLast) {
        const url = c.url ? `/${lang}/my${c.url}` : '#';
        return <Breadcrumb.Item href={ url } linkAs={ Link } linkProps={ {to: url} }>
            { c.title }
          </Breadcrumb.Item>
      } else {
        return <Breadcrumb.Item active>{ c.title }</Breadcrumb.Item>
      }
    });
  };

  return <Breadcrumb>
    <Breadcrumb.Item href={ `/${lang}/` }>{ gettext('Главная') }</Breadcrumb.Item>
    { breadcrumbs && getItems(breadcrumbs) }
  </Breadcrumb>
};

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.array.isRequired,
  setBreadcrumbsArray: PropTypes.func.isRequired,
}

let mapStateToProps = (state) => {
  return {
    breadcrumbs: state.app.breadcrumbs,
  }
};

export default compose(
  connect(mapStateToProps, { setBreadcrumbsArray }),
)(Breadcrumbs);

